import { useEffect } from 'react'

//HACK: harcoded calculation of buttons & snackbar heights
//TODO: add ref to cancel & error snackbars to get height and update form margin
const BUTTON_HEIGHT = 51
const CANCEL_SNACKBAR_HEIGHT = 78
const ERROR_SNACKBAR_HEIGHT = 32

const useShippingSendActionsLayout = (
  showSubmitButton,
  showSendError,
  showCancelConfirmation,
) => {
  const snackbarHeight = showCancelConfirmation
    ? CANCEL_SNACKBAR_HEIGHT
    : showSendError
    ? ERROR_SNACKBAR_HEIGHT
    : 0

  const buttonsNumber = showSubmitButton ? 2 : 1
  const snackbarBottomPosition = buttonsNumber * BUTTON_HEIGHT

  const formMarginBottom = snackbarBottomPosition + snackbarHeight

  useEffect(() => {
    const scrollToBottom = () => {
      window.scrollTo({
        top: window.innerHeight + formMarginBottom,
        behavior: 'smooth',
      })
    }

    if (showSendError || buttonsNumber === 2) {
      scrollToBottom()
    }
  }, [showSendError, buttonsNumber, formMarginBottom])

  return snackbarBottomPosition
}

export default useShippingSendActionsLayout
